exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* * { outline: 1px solid red !important; } */\n", ""]);

// exports
